import React from "react";

import { Button, Layout, Result, Row, Space } from "antd";
import { useIntl } from "react-intl";
import { env } from "config";

import "./Maintenance.less";

export type MaintenanceProps = {
  title: string,
  description: string,
}

export function Maintenance(props: MaintenanceProps) {
  const { title, description } = props;
  const intl = useIntl();

  return (
    <Layout className="maintenance-mode">
      <Row
        justify="center"
        align="middle"
      >
        <Space direction="vertical" align="center">
          <Result
            status="500"
            title={title}
            subTitle={description}
            extra={
              <Button
                type="primary"
                onClick={() => window.location.replace(env.REACT_APP_JMIX_IO)}
              >
                {intl.formatMessage({ id: "jmix-store.maintenance.back" })}
              </Button>
            }
          />
        </Space>
      </Row>
    </Layout>
  );
}